import React from "react"
import { Icon as ChakraIcon } from "@chakra-ui/react"
import paths from "./paths"

export function Icon({ name, ...rest }) {
  return (
    <ChakraIcon {...rest}>
      <use href={`#${paths[name].id}`} />
    </ChakraIcon>
  )
}
